import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

import Trade from './routes/Trade'
import Nav from './components/Nav'
import Footer from "./components/Footer";

function App() {
  const [authenticated, setAuthenticated] = useState(false)
  const [steamid, setSteamId] = useState("")
  return (
    <BrowserRouter>
      <Nav setSteamId={setSteamId} authenticated={authenticated} setAuthenticated={setAuthenticated}/>
      <Routes>
        <Route path="/" element={<Trade isAuthenticated={authenticated}/>}>
          <Route index element={<Trade isAuthenticated={authenticated} />} />
        </Route>
      </Routes>
      <Footer/>
    </BrowserRouter>
  );
}


export default App;
